//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import action from './action';
import { dataController } from 'components/app';
import config from 'config';

export default {
  name: 'index',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  components: {
    dataController
  },
  data() {
    return {
      pageTitle: '智能皮肤检测报告',
      reportData: {
        code: undefined,
        data: {},
        msg: undefined
      },
      emptyData: {
        text: '您还没有相应记录',
        image: '/static/img/app/no_article.png'
      },
      headImg: '',
      skinReportData: {},
      commonConclusion: [],
      liveImg: '',
      ageNum: 0,
      skinAge: 0,
      skinAgeProgress: 0,
      timer: undefined,
    }
  },
  created() {
    
  },
  async mounted() {
    await this.init();
    this.initRadarChart();
    // this.initLineChart();
  },
  methods: {
    ...action
  }
}



// WEBPACK FOOTER //
// ./src/module/app/skinReport/page.vue